import styled, { css } from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { linkAppearance } from './utils/linkAppearance.js';

var fontSize = {
  large: themeGet('fontSize.large'),
  medium: themeGet('fontSize.medium'),
  small: themeGet('fontSize.small'),
  tiny: themeGet('fontSize.tiny')
};
var linkBase = css(["font-size:", ";display:inline-block;text-decoration:none;cursor:pointer;"], function (props) {
  return fontSize[props.$size];
});
var StyledAnchor = styled.a.withConfig({
  displayName: "StyledAnchor",
  componentId: "sc-i0sjp8-0"
})(["", ";", ";"], linkBase, function (props) {
  return linkAppearance(props.$appearance);
});

export { StyledAnchor };
